import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import GroupsIcon from '@mui/icons-material/Groups';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { colors } from './landingTheme';

export const navItems = [
    { label: 'Training', href: '#training' },
    { label: 'Fortschritt', href: '#fortschritt' },
    { label: 'Gruppen', href: '#gruppen' },
];

export const features = [
    {
        id: 'training',
        icon: <FitnessCenterIcon />,
        title: 'Training erfassen',
        text: 'Sätze, Wiederholungen und Gewicht schnell dokumentieren.',
        tone: colors.blue,
    },
    {
        id: 'fortschritt',
        icon: <QueryStatsIcon />,
        title: 'Fortschritt sehen',
        text: 'Historie, Bestwerte und Gewichtsentwicklung auf einen Blick.',
        tone: colors.green,
    },
    {
        id: 'gruppen',
        icon: <GroupsIcon />,
        title: 'Gemeinsam trainieren',
        text: 'Gruppen, Kalender und Kommentare für gemeinsame Sessions.',
        tone: '#8b5cf6',
    },
    {
        id: 'motivation',
        icon: <EmojiEventsIcon />,
        title: 'Motivation behalten',
        text: 'Highscores und Ziele halten den nächsten Satz sichtbar.',
        tone: '#fbbf24',
    },
];

export const screenRows = [
    { name: 'Bankdrücken', value: '82,5 kg', trend: '+5,0 kg' },
    { name: 'Kniebeuge', value: '105 kg', trend: '+7,5 kg' },
    { name: 'Rudern', value: '68 kg', trend: '+2,5 kg' },
];
